<template>
  <div>
    <c-feature-icon
      v-if="enables.airport"
      :checked="features.airport"
      class="mr-1"
      icon="flight_takeoff" alt="空港近郊"
    />
    <c-feature-icon
      v-if="enables.station"
      :checked="features.station"
      class="mr-1"
      icon="directions_transit_filled" alt="駅近"
    />
    <c-feature-icon
      v-if="enables.keykey"
      :checked="features.keykey"
      icon="local_convenience_store" alt="キーロッカー対応"
    />
  </div>
</template>

<script>
import CFeatureIcon from '../CFeatureIcon'

export default {
  name: 'CFeatures',
  components: {
    CFeatureIcon
  },
  props: {
    enables: {
      type: Object,
      required: true
    },
    features: {
      type: Object,
      required: true
    }
  }
}
</script>
